<template>
  <div class="customer-dashboard">
    <AppPageHeader title="Your Active Project">
      <template #actions>
        <BaseButton v-if="customerProfile?.id" variant="accent" :to="{ name: 'ListCustomerProjects', params: { customerId: customerProfile.id } }">
          View All Projects
        </BaseButton>
      </template>
    </AppPageHeader>
    <div v-if="latestProject">
      <CustomerProjectCard :project="latestProject" />
    </div>
    <div v-else class="card p-6">
      <div class="flex flex-col items-center justify-center py-8 text-center">
        <div class="text-slate-400 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h3 class="text-lg font-medium text-slate-900 mb-1">No Active Projects</h3>
        <p class="text-slate-500">You don't have any projects in progress or awaiting approval.</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useAuth } from '@/composables/useAuth'
import { useQuery } from '@tanstack/vue-query'
import CustomerService from '@/services/CustomerService'
import ProjectService from '@/services/ProjectService'
import { orderByDesc, eq } from '@/utils/queryFilters'
import CustomerProjectCard from '@/components/project/CustomerProjectCard.vue'
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import BaseButton from '@/components/base/BaseButton.vue'

const { currentUser } = useAuth()

const { data: customerProfile } = useQuery({
  queryKey: ['customerProfile', currentUser.value?.id],
  queryFn: async () => {
    const data = await new CustomerService().find_by('accountId', '==', currentUser.value?.id)
    return data[0] || null
  },
  enabled: !!currentUser.value?.id
})

const enableProjectFetch = computed(() => !!customerProfile.value?.id)
const { data: latestProject } = useQuery({
  queryKey: ['latestProject', customerProfile.value?.id],
  queryFn: async () => {
    const projectService = new ProjectService()
    const project = await projectService.where(
      [eq('customerId', customerProfile.value?.id)],
      [orderByDesc('updatedAt')],
      1
    )
    return project[0] || null
  },
  enabled: enableProjectFetch
})
</script>
